import {
  accountProfile,
  unbindQw,
  unbindGc,
  unbindWechat,
  unbindDingding,
  editTruename,
  fetchLoginLog
} from '@/services/account'
import {
  validName
} from '@/services/index'
export default {
  namespaced: true,
  state: {
    loadingDetails: false,
    decorators: {
    },
    accountDetail: {},
    submitting: false
  },
  mutations: {
    setSubmitting (state, type) {
      state.submitting = type
    },
    setLoadingDetails (state, type) {
      state.loadingDetails = type
    },
    setAccountDetail (state, datas) {
      state.accountDetail = datas
    }
  },
  actions: {
    async fetchAccountInfoDatas ({ commit }) {
      commit('setLoadingDetails', true)
      const chain = await accountProfile()
        .onSuccess((raw) => {
          commit('setAccountDetail', raw)
        })
        .onNetComplete(() => {
          commit('setLoadingDetails', false)
        })
        .config({ tip: false })
      return chain
    },
    async unBindQw ({ commit, dispatch }) {
      const chain = await unbindQw()
        .onSuccess(async (raw) => {
          const chain2 = await dispatch('fetchAccountInfoDatas')
          chain2.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async unBindGc ({ commit, dispatch }) {
      const chain = await unbindGc()
        .onSuccess(async (raw) => {
          const chain2 = await dispatch('fetchAccountInfoDatas')
          chain2.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async unbindWechat ({ commit, dispatch }) {
      const chain = await unbindWechat()
        .onSuccess(async (raw) => {
          const chain2 = await dispatch('fetchAccountInfoDatas')
          chain2.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async unbindDingding ({ commit, dispatch }) {
      const chain = await unbindDingding()
        .onSuccess(async (raw) => {
          const chain2 = await dispatch('fetchAccountInfoDatas')
          chain2.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async ajaxEditTruename ({ commit, dispatch }) {
      const chain = await editTruename()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async fetchLoginLogData ({ commit, dispatch }) {
      commit('setLoadingDetails', true)
      const chain = await fetchLoginLog()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
          commit('setLoadingDetails', false)
        })
        .config({ tip: false })
      return chain
    },
    async validName ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await validName()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    }
  }
}
